import {
    SYSTEM_ALT_LOG_LAST_READING_INFO_OPEN_MODAL,
    SYSTEM_ALT_LOG_LAST_READING_INFO_REQUEST,
    SYSTEM_ALT_LOG_LAST_READING_INFO_RESULT
} from 'Redux/actionTypes';

export const systemAlertLastReadingInfoOpenModal = (open, device) => ({
    type: SYSTEM_ALT_LOG_LAST_READING_INFO_OPEN_MODAL,
    payload: { open, device }
})

export const systemAlertLastReadingInfoRequest = (data) => ({
    type: SYSTEM_ALT_LOG_LAST_READING_INFO_REQUEST,
    payload: data
})

export const systemAlertLastReadingInfoResult = (result) => ({
    type: SYSTEM_ALT_LOG_LAST_READING_INFO_RESULT,
    payload: result
})